<template>
  <div class="my-auto flex h-full flex-col items-center justify-center">
    <img src="/assets/illustrations/oc-connecting.svg" alt="" class="w-5/6 max-w-80" />
    <div class="mt-10 flex w-5/6 max-w-96 flex-col gap-4">
      <p class="text-body-large-m">{{ t("new_ticket_which_shipment") }}</p>
      <p class="text-body-default text-fgr-secondary">{{ t("bulk_tickets.intro") }}</p>
      <p class="text-body-default text-fgr-secondary">{{ t("bulk_tickets.input_hint") }}</p>
      <InputTextarea v-model="input" :placeholder="t('set_package_number')" />
      <p class="text-body-default text-fgr-secondary">{{ t("bulk_tickets.important") }}</p>
      <p v-if="packageNumbers.length > 1" class="text-body-default-m">
        {{ t("bulk_tickets.parsed_count", packageNumbers.length) }}
      </p>
      <SelectCheckbox v-model="confirmed" framed :title="t('bulk_tickets.confirm')" />
      <Button
        :variant="ButtonVariant.Primary"
        :disabled="!packageNumbers.length || !confirmed"
        class="w-full"
        @click="() => packageNumbers.length && confirmed && $emit('submit', packageNumbers)"
      >
        {{ t("new_ticket") }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n();
  const input = ref<string>("");
  const confirmed = ref(false);

  // New lines, commas or semicolons, so a pasted CSV/Excel column works; quotes and a leading # are dropped
  const packageNumbers = computed(() => [
    ...new Set(
      input.value
        .split(/[\s,;]+/)
        .map((value) => value.replace(/^["'#]+|["']+$/g, ""))
        .filter(Boolean)
    ),
  ]);

  defineEmits<{
    submit: [packageNumbers: string[]];
  }>();
</script>
